import React, { useState, useEffect } from 'react';
import chevronDown from './../../../img/icons/chevronDown.svg';
import DisabledAccess from '../../../img/icons/DisabledAccess.svg';
import Parking from '../../../img/icons/Parking.svg';
import BabyFacilities from '../../../img/icons/BabyFacilities.svg';
import Wifi from '../../../img/icons/Wifi.svg';
import DeliveryIcon from './../../../img/icons/Delivery.svg';
import errorIcon from './../../../img/icons/error.svg';
import locationPin from '../../../img/icons/LocationFill.svg';
import { getDistanceText } from '../../../helpers/commonHelpers';
import DeliveryBadge from './DeliveryBadge';
import { useConfig } from '../../../helpers/useConfig';

const RestaurantCard = ({ restaurant, handleRestaurantSelected, setProspectiveRestaurant, isDelivery }) => {
    const mapStyle = '&style=element:geometry|color:0xd0d2d7&style=element:labels.text.fill|color:0x161e35&style=element:labels.text.stroke|color:0xe2e5f6&style=feature:administrative|element:geometry|visibility:off&style=feature:administrative|element:geometry.stroke|color:0xc9b2a6&style=feature:administrative.land_parcel|element:geometry.stroke|color:0xffffff&style=feature:administrative.land_parcel|element:labels.text.fill|color:0x8a8f9a&style=feature:landscape.man_made|color:0x454b5d|visibility:off&style=feature:landscape.natural|element:geometry|color:0xd0d2d7&style=feature:poi|visibility:off&style=feature:poi|element:geometry|visibility:on&style=feature:poi|element:labels.text.fill|color:0x454b5d&style=feature:poi.park|element:geometry.fill|color:0xbcb194|visibility:on&style=feature:poi.park|element:labels.text.fill|color:0x447530&style=feature:road|element:geometry|color:0xf6f6f6&style=feature:road|element:labels.icon|visibility:off&style=feature:road.arterial|element:geometry|color:0xfdfcf8&style=feature:road.arterial|element:geometry.stroke|color:0x8a8f9a|visibility:on&style=feature:road.highway|visibility:off&style=feature:road.highway|element:geometry|color:0x8a8f9a&style=feature:road.highway|element:geometry.stroke|color:0x8a8f9a|visibility:off&style=feature:road.highway.controlled_access|element:geometry|color:0xe98d58&style=feature:road.highway.controlled_access|element:geometry.stroke|color:0xc6c5c5&style=feature:road.local|element:labels.text.fill|color:0x454b5d&style=feature:transit|visibility:off&style=feature:transit.line|color:0x6d6d6d&style=feature:transit.line|element:geometry|color:0xdfd2ae&style=feature:transit.line|element:labels.text.fill|color:0x454b5d&style=feature:transit.line|element:labels.text.stroke|color:0xe2e5f6&style=feature:transit.station|visibility:off&style=feature:transit.station|element:geometry|color:0x8a8f9a&style=feature:water|element:geometry.fill|color:0x8c9add&style=feature:water|element:labels.text|color:0x161e35&style=feature:water|element:labels.text.fill|color:0x161e35';

    const imageUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${restaurant.latitude},${restaurant.longitude}&zoom=13&size=560x321&maptype=roadmap&key=AIzaSyChhb6qMwH3kGF8USJ63qfBTLkoZ1NIsjo ${mapStyle}`;
    const [isActive, setActive] = useState(false);
    const [canSwitchToCollection, setSwitchToCollection] = useState(false);
    const [restaurantOrderCTALabel, setRestaurantOrderCTALabel] = useState('');
    const config = useConfig();
    const toggleClass = () => {
        setActive(!isActive);
    };

    useEffect(() => {
        getRestaurantOrderCTALabel();
    }, []);

    const getRestaurantOrderCTALabel = () => {
        if (isDelivery) {
            if (!restaurant?.openingTimes?.isOpenForDelivery && restaurant?.openingTimes?.isOpenForCollection) {
                setSwitchToCollection(true);
                setRestaurantOrderCTALabel('Order for collection');
                return;
            }
            else if (restaurant?.openingTimes?.isOpenForDelivery && !restaurant?.openingTimes?.isOpenForCollection) {
                setRestaurantOrderCTALabel('Order for delivery');
                return;
            }
        }
        else {
            if ( restaurant?.openingTimes?.isOpenForDelivery && !restaurant?.openingTimes?.isOpenForCollection) {
                setRestaurantOrderCTALabel('Order for delivery');
                return;
            }
            else if (!restaurant?.openingTimes?.isOpenForDelivery && restaurant?.openingTimes?.isOpenForCollection) {
                setSwitchToCollection(true);
                setRestaurantOrderCTALabel('Order for collection');
                return;
            }
        }
        if (restaurant.delivery) {
            if (!restaurant.isCollectionDisabled &&
                (restaurant.isDeliveryDisabled)) {
                setSwitchToCollection(true);
                setRestaurantOrderCTALabel('Order for collection');
                return;
            }
            else {
                setRestaurantOrderCTALabel('Order for delivery');
                return;
            }
        } else {
            setSwitchToCollection(true);
            setRestaurantOrderCTALabel('Order for collection');
            return;
        }

    };
    return (
        <div className='card restaurant-card rounded-5 mb-3' data-testid='restaurant-card'>
            <div className="card-content p-0">
                <div className="content mb-0">
                    <div className="block mb-2">
                        {restaurant.delivery ?
                            <div>
                            </div>
                            :
                            <div style={{ display: 'flex', gap: '0.75rem' }}>
                                {restaurant.facilities.includes('Disabled Access') && (<div className="level-item is-narrow icon is-small">
                                    <img width={25} height={25} className="img" src={DisabledAccess} alt="DisabledAccess" id='DisabledAccess' />
                                </div>)}
                                {restaurant.facilities.includes('Parking') && (<div className="level-item is-narrow icon is-small">
                                    <img width={25} height={25} className="img" src={Parking} alt="Parking" id='Parking' />
                                </div>)}
                                {restaurant.facilities.includes('Baby Facilities') && (<div className="level-item is-narrow icon is-small">
                                    <img width={25} height={25} className="img" src={BabyFacilities} alt="BabyFacilities" id='BabyFacilities' />
                                </div>)}
                                {restaurant.facilities.includes('WiFi') && (<div className="level-item is-narrow icon is-small">
                                    <img width={25} height={25} className="img" src={Wifi} alt="WiFi" id='Wifi' />
                                </div>)}
                                {restaurant.facilities.includes('Delivery') && (<div className="level-item is-narrow icon is-small">
                                    <img width={25} height={25} className="img" src={DeliveryIcon} alt="Delivery" id='Delivery' />
                                </div>)}
                            </div>}
                    </div>
                    <div className="block">
                        <div className="level is-mobile mb-3">
                            {restaurant.name && (
                                <div className="level-left is-flexible is-shrinkable mr-4">
                                    <div className="content">
                                        <h4 className="title mb-0" data-testid='restaurantCard-name'>{restaurant.name}</h4>
                                    </div>
                                </div>
                            )}
                            {restaurant.distance && (
                                <div className="level-right is-narrow">
                                    <p className="subtitle is-6" data-testid='restaurantCard-distance' style={{ fontSize: '16px' }}>
                                        {getDistanceText(restaurant.distance, config.BRAND)}
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                    {restaurant.openingTime !== undefined && restaurant.closingTime !== undefined ? (
                        <div className="block" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                            <small data-testid='restaurantCard-opening-time'>
                                Open: {restaurant.openingTime != undefined && restaurant.openingTime} -{' '}
                                {restaurant.closingTime != undefined && restaurant.closingTime}
                            </small>
                            {
                                restaurant.delivery && restaurant.delivery.isCheapest &&
                                <DeliveryBadge type="fee" />
                            }
                        </div>
                    ) : null}
                    <div
                        className="level is-align-top is-mobile mb-4"
                        onClick={() => toggleClass()}
                        id="toggleClass"
                        data-testid='restaurantCard-toggle-map-button'
                    >
                        <div className="level-left is-flexible is-shrinkable">
                            {
                                !restaurant.delivery ?
                                    <>
                                        {(restaurant.fullAddress || restaurant.telephone) && (
                                            <div className="block mb-0" style={{ fontSize: '16px' }}>
                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25em' }}>{!!restaurant.fullAddress && restaurant.fullAddress?.split(',').map((r, i, arr) => <span key={'i' + r} style={{ fontSize: '16px', marginBottom: 0, whiteSpace: 'nowrap' }} data-testid='restaurantCard-address'>{r + `${i === arr.length - 1 ? '' : ','}`}</span>)}</div>
                                                {!!restaurant.telephone && isActive && <p style={{ fontSize: '16px' }} data-testid='restaurantCard-telephone'>{restaurant.telephone}</p>}
                                                {!!restaurant.collectionMessage && (
                                                    <small className="message-wrapper is-flex is-align-items-center">
                                                        <i className="icon is-small mr-3">
                                                            <img src={errorIcon} alt="error" />
                                                        </i>
                                                        <p id="unavailable" data-testid='unavailable'>{restaurant.collectionMessage}</p>
                                                    </small>
                                                )}
                                            </div>
                                        )}
                                    </>
                                    :
                                    <div className="block mb-0">
                                        {
                                            !restaurant.isDeliveryDisabled &&
                                            <small className="is-flex is-align-items-center">
                                                <i className="icon mr-3">
                                                    <img src={DeliveryIcon} alt="delivery" />
                                                </i>
                                                <p style={{ fontWeight: 600 }} >{restaurant.delivery.estimated_duration.begin} - {restaurant.delivery.estimated_duration.end} mins</p>
                                            </small>
                                        }
                                        {!!restaurant.deliveryMessage && (
                                            <small className="message-wrapper is-flex is-align-items-center">
                                                <i className="icon is-small mr-3">
                                                    <img src={errorIcon} alt="error" />
                                                </i>
                                                <p id="unavailable" data-testid='unavailable'>{restaurant.deliveryMessage}</p>
                                            </small>
                                        )}
                                    </div>
                            }
                        </div>
                        <div className="level-right is-narrow">
                            {
                                restaurant.delivery ?
                                    <>
                                        {
                                            restaurant.delivery.isFastest &&
                                            <DeliveryBadge type="speed" />
                                        }
                                    </>
                                    :
                                    <i className={`icon is-small is-animated ml-3 ${isActive ? 'is-active' : null}`}>
                                        <img src={chevronDown} alt="search" />
                                    </i>
                            }
                        </div>
                    </div>
                    <div className="block">
                        <button
                            className="btn btn-primary"
                            disabled={restaurant.delivery ? canSwitchToCollection ? restaurant.isCollectionDisabled : restaurant.isDeliveryDisabled : restaurant.isCollectionDisabled}
                            onClick={() => {
                                handleRestaurantSelected(restaurant, canSwitchToCollection);
                                setProspectiveRestaurant(restaurant, canSwitchToCollection);
                            }}
                            id='setRestaurantButton'
                        >
                            <span>{restaurantOrderCTALabel}</span>
                        </button>
                    </div>
                </div>
                {
                    !restaurant.delivery &&
                    <div id="map" className={`expanding ${isActive ? 'is-active' : null}`} data-testid='restaurantCard-map'>
                        <div className="content mt-3" style={{ position: 'relative', alignItems: 'center', justifyContent: 'center' }}>
                            <img src={imageUrl} alt="map" style={{ height: 'auto', width: '100%', position: 'relative' }} />
                            {isActive && <img src={locationPin} alt="pin" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -100%)' }} />}
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

export default RestaurantCard;
